import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-create-blank-status',
  templateUrl: './create-blank-status.component.html',
  styleUrls: ['./create-blank-status.component.scss'],
})
export class CreateBlankStatusComponent {
  additionalDemand: number;
  damageManufacturing: number;
  damagePreManufacturing: number;
  info: string;

  form: FormGroup = this.formBuilder.group({
    additionalDemand: [0, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(1)]],
    damageManufacturing: [0, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(1)]],
    damagePreManufacturing: [0, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(1)]],
    info: ['']
  });

  constructor(private dialogRef: MatDialogRef<CreateBlankStatusComponent>, private formBuilder: FormBuilder) {
  }

  discard() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close({
      additionalDemand: this.form.get('additionalDemand').value,
      damageManufacturing: this.form.get('damageManufacturing').value,
      damagePreManufacturing: this.form.get('damagePreManufacturing').value,
      info: this.form.get('info').value,
    });
  }
}

export interface CreateBlankStatusDialogData {
  posId: string;
}
